export const typeMap = {
  confirm: {
    icon: 'question',
    btnType: 'primary'
  },
  accept: {
    icon: 'checked-alt',
    btnType: 'accept'
  },
  warning: {
    icon: 'warning',
    btnType: 'warning'
  },
  danger: {
    icon: 'remove',
    btnType: 'danger'
  },
  success: {
    icon: 'accept'
  },
  info: {
    icon: 'info',
    btnType: 'primary'
  },
  error: {
    icon: 'remove',
    btnType: 'danger'
  }
}
